import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {FloorMapService} from '../../../services/floor-map.service';
import {Store, select, Action} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import {Update} from '@ngrx/entity';
import {FloorMap} from '../floor-map.model';

@Injectable()
export class FloorMapEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private floorMapService = inject(FloorMapService);

  constructor() {}

  ReadAllMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FloorMapActionTypes.GetFloorMaps),
    map((action: featureActions.GetFloorMaps) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {otp: user.otp, RegionIds: payload.regionIds} : {otp: user.otp};
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.GetFloorMap
      };
      return this.floorMapService.ReadAllMap(params).pipe(
        switchMap((res: any) => {
          // if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
          //   debugger;
          //   return [new featureActions.LoadFloorMaps({floorMaps: res.msg.body}), new featureActions.UpdateInfoSuccessAction(updateRes)];
          // } else {
          //   debugger;
          //   return [new featureActions.LoadFloorMaps({floorMaps: []}), new featureActions.UpdateInfoSuccessAction(updateRes)];
          // }

          if (res.result) {
            const finalUpdateRes = { ...updateRes, result: res.result };
            if (Array.isArray(res.msg.body)) {
              return [new featureActions.LoadFloorMaps({floorMaps: res.msg.body}), new featureActions.UpdateInfoSuccessAction(finalUpdateRes)];
            } else {
              return [new featureActions.LoadFloorMaps({floorMaps: []}), new featureActions.UpdateInfoSuccessAction(finalUpdateRes)];
            }
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        // catchError(error => {
        //   return of(new featureActions.LoadFloorMaps({floorMaps: []}));
        // })
        catchError(error => {
            const updateRes: UpdateInfoModel = {
              result: false,
              errmsg: 'Error',
              type: updateInfoType.GetFloorMap
            };
            return [new featureActions.UpdateInfoFailAction(updateRes), new featureActions.LoadFloorMaps({floorMaps: []})];
          })
      );
    })
  ));
  UpdateMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FloorMapActionTypes.GetUpdateFloorMaps),
    map((action: featureActions.GetUpdateFloorMaps) => action.payload.floorMap),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([floorMap, user]) => {
      const payload = { ...floorMap, otp: user.otp };
      return this.floorMapService.UpdateMap(payload).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.EditFloorMap };
          if (result.result) {
            const update: Update<FloorMap> = {
              id: payload.id,
              changes: payload
            };
            return  [new featureActions.UpdateFloorMap({floorMap: update}), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditFloorMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  AddFloorMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FloorMapActionTypes.GetAddFloorMaps),
    map((action: featureActions.GetAddFloorMaps) => action.payload.floorMap),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([floorMap, user]) => {
      const payload = { ...floorMap, otp: user.otp };
      return this.floorMapService.AddFloorMap(payload).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.AddFloorMap };
          if (result.result) {
              const updatedPayload = { ...payload, id: result.msg['body'] };
              return [new featureActions.AddFloorMap({floorMap: updatedPayload}), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            const errorResult = result.msg['ExtMsg'] === '0' 
              ? { ...result, errmsg: '0' }
              : result;
            return [new featureActions.UpdateInfoFailAction(errorResult)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddFloorMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  DeleteFloorMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.FloorMapActionTypes.GetDeleteFloorMaps),
    map((action: featureActions.GetDeleteFloorMaps) => action.payload.id),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([id, user]) => {
      const params = {
        otp: user.otp,
        Id: Number(id)
      };
      return this.floorMapService.DeleteFloorMap(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteFloorMap };
          if (result.result) {
            return [new featureActions.DeleteFloorMap({id: id}), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteFloorMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}



